import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Center, Stack, Button, Paper, Text, Image } from '@mantine/core';
import { IconLogin } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import { useAuthStore } from '@/stores/useAuthStore';
import logo from '@/assets/logos/SVG/Logo - ULI big .svg';

export function LoginPage() {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setIdToken = useAuthStore((s) => s.setIdToken);

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      exchangeCodeForTokens(code).then((tokens) => {
        if (tokens?.id_token) {
          setIdToken(tokens.id_token);
          if (tokens.access_token) localStorage.setItem('accessToken', tokens.access_token);
          if (tokens.refresh_token) localStorage.setItem('refreshToken', tokens.refresh_token);
          navigate('/', { replace: true });
        }
      });
    }
  }, [searchParams, navigate, setIdToken]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Center h="100vh">
      <Paper shadow="md" p="xl" radius="md" w={400}>
        <Stack align="center" gap="lg">
          <Image src={logo} h={48} w="auto" />
          <Text c="dimmed" ta="center">
            Melden Sie sich an, um die Verwaltung zu nutzen.
          </Text>
          <Button fullWidth size="lg" leftSection={<IconLogin size={20} />} onClick={login}>
            Anmelden
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}

async function exchangeCodeForTokens(code: string) {
  const domain = import.meta.env.VITE_COGNITO_DOMAIN ?? 'ulikeit-admin.auth.eu-central-1.amazoncognito.com';
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID ?? '4jvfjdu4t9dk2ub2aih4g8tgvs';
  const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? `${window.location.origin}/login`;

  try {
    const response = await fetch(`https://${domain}/oauth2/token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: clientId,
        code,
        redirect_uri: redirectUri,
      }),
    });
    return response.json();
  } catch {
    return null;
  }
}
